<template>
    <section>
        <!--工具条-->
        <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

        <!--列表-->
        <el-table :data="users"
                  v-loading="listLoading"
                  style="width: 100%"
                  @select="dialogCheck"
                  @row-click="selectCurrentRow"
                  ref="table"
                  class="custom-tbl">
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column type="index" width="80"> </el-table-column>
            <!--<el-table-column prop="Id" label="ID" width="100" sortable>
            </el-table-column>-->
            <el-table-column prop="btitle" label="标题" width="" sortable>
            </el-table-column>
            <el-table-column prop="OrderNumber" label="序号" width="" sortable>
            </el-table-column>
            <!--<el-table-column prop="bcontent" label="内容" width="400" sortable>
                <template slot-scope="scope">
                    <span v-html="scope.row.bcontent.substring(0, 100)"></span>
                </template>
            </el-table-column>-->
            <el-table-column prop="bCreateTime"
                             label="创建时间"
                             :formatter="formatCreateTime"
                             width="250"
                             sortable>
            </el-table-column>

            <!-- <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column> -->
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next"
                           @current-change="handleCurrentChange"
                           :page-size="20"
                           :total="total"
                           style="float: right">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑"
                   :visible.sync="editFormVisible"
                   v-model="editFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editForm"
                     label-width="80px"
                     :rules="editFormRules"
                     ref="editForm">
                <el-form-item label="标题" prop="btitle">
                    <el-input v-model="editForm.btitle"></el-input>
                </el-form-item>

                <el-form-item label="分类">
                    <el-select v-model="editForm.bcategory" placeholder="请选择分类">
                        <el-option :key="0" :label="'未选择分类'" value=""></el-option>
                        <el-option v-for="(item,index) in allBcategory"
                                   :key="'Areas2'+index"
                                   :label="item.Name"
                                   :value="item.Value">
                            <span style="float: left">{{ item.Name }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="作者" prop="bsubmitter">
                    <el-input v-model="editForm.bsubmitter"></el-input>
                </el-form-item>
                <el-form-item label="序号" prop="OrderNumber">
                    <el-input v-model="editForm.OrderNumber"></el-input>
                </el-form-item>
                <!--使用编辑器-->
                <el-form-item label="详细" prop="bcontent">
                    <div class="edit_container">
                        <quill-editor v-model="editForm.bcontent"
                                      ref="myQuillEditor"
                                      class="editer"
                                      :options="editorOption"
                                      @ready="onEditorReady($event)"></quill-editor>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="editSubmit"
                           :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增"
                   :visible.sync="addFormVisible"
                   v-model="addFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="addForm"
                     label-width="80px"
                     :rules="addFormRules"
                     ref="addForm">

                <el-form-item label="标题" prop="btitle">
                    <el-input v-model="addForm.btitle"></el-input>
                </el-form-item>

                <el-form-item label="分类">
                    <el-select v-model="addForm.bcategory" placeholder="请选择分类">
                        <el-option :key="0" :label="'未选择分类'" value=""></el-option>
                        <el-option v-for="(item,index) in allBcategory"
                                   :key="'Areas1'+index"
                                   :label="item.Name"
                                   :value="item.Value">
                            <span style="float: left">{{ item.Name }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="作者" prop="bsubmitter">
                    <el-input v-model="addForm.bsubmitter"></el-input>
                </el-form-item>
                <el-form-item label="序号" prop="OrderNumber">
                    <el-input v-model="addForm.OrderNumber"></el-input>
                </el-form-item>
                <!--使用编辑器-->
                <el-form-item label="详细" prop="bcontent">
                    <div class="edit_container">
                        <quill-editor v-model="addForm.bcontent"
                                      ref="myQuillEditor"
                                      class="editer"
                                      :options="editorOption"
                                      @ready="onEditorReady($event)"></quill-editor>
                    </div>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="addSubmit"
                           :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>





        <!--// 隐藏图片上传表单-->
        <el-upload class="avataruploaderTip"
                   ref="uploadtip"
                   :limit="999"
                   action="#"
                   :show-file-list="false"
                   :http-request="uploadImgTip">
        </el-upload>
        <!--// 视频上传弹出框-->
        <el-dialog title="视频上传"
                   :visible.sync="videoFlag"
                   :close-on-click-modal="false"
                   class="editerV"
                   width="500px">
            <div class="editerVideo">
                <div class="editerVideo_title">
                    <div :class="['editerVideo_title_item',videoTab.tabUrl?'editerVideo_title_act':''] " @click="onVideoTab(1)">添加链接</div>
                    <div :class="['editerVideo_title_item',videoTab.tabUpd?'editerVideo_title_act':''] " @click="onVideoTab(2)">上传视频</div>
                </div>
                <div class="editerVideo_main">
                    <div class="editerVideo_main_url" v-if="videoTab.tabUrl">
                        <div>视频地址：</div>
                        <el-input size="small" v-model="videoUrl" style="width:300px"></el-input>
                        <el-button type="primary" style=" margin-left:10px;  height:30px" @click="upVideoUrl" size="small">添加</el-button>
                    </div>
                    <div v-if="videoTab.tabUpd">
                        <div v-if="videoProgress" class="videoProgress">视频上传中，请耐心等待！</div>
                        <el-upload v-else
                                   class="avatar-uploader_video"
                                   :limit=1
                                   action="#"
                                   :show-file-list="false"
                                   :http-request="uploadVideoTip">
                            <i class="el-icon-plus avatar-uploader-videoiocn"></i>
                        </el-upload>

                    </div>
                </div>
            </div>
        </el-dialog>
        <!----上传文件--->
        <el-upload class="uploadFile"
                   action="#"
                   name="file"
                   :show-file-list="false"
                   :http-request="uploadFile"></el-upload>




    </section>
</template>

<script>
import util from "../../../util/date";
import { getBlogListPage, removeBlog, editBlog, addBlog, uploadArticleFiles } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
/*import global from '../../components/Global'//引用全局模块*/
import { quillEditor, Quill } from "vue-quill-editor"; //调用编辑器
// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";


import { ImageDrop } from 'quill-image-drop-module';
   /* import imageResize from 'quill-image-resize-module';*/
    Quill.register('modules/imageDrop', ImageDrop);
    /* Quill.register('modules/imageResize', imageResize);*/
    //import { ImageResize } from 'quill-image-resize-module';
    //Quill.register('modules/imageResize', ImageResize);


export default {
        components: {
            Toolbar,
            //使用编辑器
            quillEditor
        },
        data() {
            return {
                buttonList: [],
                currentRow: null,
                filters: {
                    LinkUrl: "",
                },
                users: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [], //列表选中列

                addDialogFormVisible: false,
                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    btitle: [
                        { required: true, message: "请输入标题", trigger: "blur" },
                    ],
                },
                //编辑界面数据
                editForm: {
                    Id: 0,
                    btitle: "",
                    bsubmitter: "",
                    bcategory: "",
                    bcontent: "",
                    OrderNumber: 0,
                },

                addFormVisible: false, //新增界面是否显示
                addLoading: false,
                addFormRules: {
                    btitle: [
                        { required: true, message: "请输入标题", trigger: "blur" },
                    ],
                },
                //新增界面数据
                addForm: {
                    btitle: "",
                    bsubmitter: "",
                    bcategory: "",
                    bcontent: "",
                    OrderNumber: 0,
                },

                allBcategory: [{ Name: "用户条款", Value: "UserItem" }, { Name: "隐私政策", Value: "Privacy" }, { Name: "注意事项", Value: "Attention" }, { Name: "服务协议", Value: "Service" }, { Name: "班车时间表", Value: "CarSchedule" }, { Name: "计费规则", Value: "BillingRules" }, { Name: "寄件地区说明", Value: "SendRegion" }, { Name: "收件地区说明", Value: "RecipientRegion" }, { Name: "客服电话", Value: "CustomerServicePhone" }, { Name: "其他", Value: "Other" }],

                //配置上传视频图片start

                // 配置项
                editorOption: {
                    modules: {
                        //imageDrop: true,      //图片拖拽
                        //imageResize: {          //放大缩小
                        //    displaySize: true
                        //},
                        toolbar: {
                            container: [
                                //['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
                                //[{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
                                //[{ 'list': 'ordered' }, { 'list': 'bullet' }], //列表
                                //[{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
                                //[{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
                                //[{ 'direction': 'rtl' }], // 文本方向
                                //['clean'], //清除字体样式
                                //['image', 'video'] //上传图片、上传视频

                                ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                                ["blockquote", "code-block"], // 引用  代码块
                                [{ 'header': 1 }, { 'header': 2 }], // 1、2 级标题
                                [{ 'list': "ordered" }, { 'list': "bullet" }], // 有序、无序列表
                                [{ 'script': "sub" }, { 'script': "super" }], // 上标/下标
                                [{ 'indent': "-1" }, { 'indent': "+1" }], // 缩进
                                // [{'direction': 'rtl'}],                         // 文本方向
                                [{ 'size': ["small", false, "large", "huge"] }], // 字体大小
                                [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 标题
                                [{ 'color': [] }, { 'background': [] }], // 字体颜色、字体背景颜色
                                [{ 'font': [] }], // 字体种类
                                [{ 'align': [] }], // 对齐方式
                                ["clean"], // 清除文本格式
                                ["link", "image", "video", "upload"] // 链接、图片、视频、文件


                            ],
                            handlers: {
                                'video': (val) => {
                                    // 覆盖默认的上传视频
                                    this.onVideo();
                                },
                                'image': (value) => {
                                    // 覆盖默认的图片上传
                                    // 获取光标所在的位置
                                    var range = this.$refs.myQuillEditor.quill.getSelection();
                                    if (range == null) {
                                        this.indexVideo = 0;
                                    } else {
                                        this.indexVideo = range.index;
                                    }
                                    // 点击隐藏的上传表单
                                    if (value) {
                                        document.querySelector('.avataruploaderTip input').click();
                                    } else {
                                        this.quill.format('image', false)
                                    }
                                },
                                'upload': (val) => {
                                    // 点击隐藏的上传表单
                                    if (val) {
                                        document.querySelector('.uploadFile input').click();
                                    }
                                },
                            }
                        }
                    },
                    placeholder: '请输入',
                    readyOnly: false, //是否只读
                    theme: 'snow', //主题 snow/bubble
                    syntax: true, //语法检测
                },
                // 相关变量
                indexVideo: 0,
                videoUrl: '',
                videoTab: {
                    tabUrl: true,
                    tabUpd: false
                },
                videoProgress: false,
                videoFlag: false,
                //配置上传视频图片end

            };
        },
        methods: {
            dialogCheck(selection, row) {
                this.currentRow = null;
                this.$refs.table.clearSelection();
                if (selection.length === 0) {
                    return;
                }
                if (row) {
                    this.selectCurrentRow(row);
                }
            },
            selectCurrentRow(val) {
                if (val) {
                    this.currentRow = val;
                    this.$refs.table.clearSelection();
                    this.$refs.table.toggleRowSelection(val, true);
                }
            },
            callFunction(item) {
                this.filters = {
                    name: item.search,
                };
                this[item.Func].apply(this, item);
            },
            //性别显示转换
            formatbcontent: function (row, column) {
                return row.bcontent ? row.bcontent.substring(20) : "N/A";
            },
            formatCreateTime: function (row, column) {
                return !row.bCreateTime || row.bCreateTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.bCreateTime), "yyyy-MM-dd");
            },
            handleCurrentChange(val) {
                this.page = val;
                this.handleQuery();
            },
            // 准备富文本编辑器
            onEditorReady(quill) {
                console.log("editor ready!", quill);
            },
            //获取用户列表
            handleQuery() {
                let para = {
                    page: this.page,
                    key: this.filters.name,
                    //bcategory:'UserItem',
                };
                this.listLoading = true;

                //NProgress.start();
                getBlogListPage(para).then((res) => {
                    if (res.data.response != null) {
                        this.total = res.data.response.dataCount;
                        this.users = res.data.response.data;
                    }
                    
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            //删除
            handleDel() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要删除的一行数据！",
                        type: "error",
                    });

                    return;
                }
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        this.listLoading = true;
                        //NProgress.start();
                        let para = { id: row.Id };
                        removeBlog(para).then((res) => {
                            if (util.isEmt.format(res)) {
                                this.listLoading = false;
                                return;
                            }
                            this.listLoading = false;
                            //NProgress.done();
                            if (res.data.success) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                            }

                            this.handleQuery();
                        });
                    })
                    .catch(() => { });
            },
            //显示编辑界面
            handleEdit() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error",
                    });

                    return;
                }
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
                //console.log(row.Id);
                //this.$router.replace(`/Blog/Detail/${row.Id}`);

                //// this.$message({
                ////     message: "功能正在陆续开发中...",
                ////     type: 'error'
                //// });
            },
            //显示新增界面
            handleAdd() {
                this.addFormVisible = true;
                this.addForm = {
                    btitle: "",
                    bsubmitter: "",
                    bcategory: "",
                    bcontent: "",
                    OrderNumber: 0,
                };
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.editForm);

                            //para.bUpdateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
                            //para.bcategory = "0";
                            if (para.bcategory == null || para.bcategory == "") {
                                this.$message({
                                    message: "请选择分类",
                                    type: "success",
                                });
                                this.editLoading = false;
                                return;
                            }
                            editBlog(para).then((res) => {
                                if (util.isEmt.format(res)) {
                                    this.editLoading = false;
                                    return;
                                }
                                if (res.data.success) {
                                    this.editLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.$refs["editForm"].resetFields();
                                    this.editFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.editLoading = false;
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                }
                            });
                        });
                    }
                });
            },
            //新增
            addSubmit: function () {
                let _this = this;
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.addLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            /*para.bcategory = "UserItem"*/;
                            if (para.bcategory == null || para.bcategory == "") {
                                this.$message({
                                    message: "请选择分类",
                                    type: "success",
                                });
                                this.addLoading = false;
                                return;
                            }
                            //para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
                            //para.ModifyTime = para.CreateTime;
                            //para.IsDeleted = false;

                            //var user = JSON.parse(window.localStorage.user);

                            //if (user && user.uID > 0) {
                            //    para.CreateId = user.uID;
                            //    para.CreateBy = user.uRealName;
                            //} else {
                            //    this.$message({
                            //        message: "用户信息为空，先登录",
                            //        type: "error",
                            //    });
                            //    _this.$router.replace(
                            //        _this.$route.query.redirect ? _this.$route.query.redirect : "/"
                            //    );
                            //}

                            addBlog(para).then((res) => {
                                if (util.isEmt.format(res)) {
                                    this.addLoading = false;
                                    return;
                                }
                                if (res.data.success) {
                                    this.addLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.$refs["addForm"].resetFields();
                                    this.addFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.addLoading = false;
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                }
                            });
                        });
                    }
                });
            },


            // 富文本相关
            onVideo() {
                this.videoFlag = true;
                //当编辑器中没有输入文本时，这里获取到的 range 为 null   获取光标位置
                var range = this.$refs.myQuillEditor.quill.getSelection();
                if (range == null) {
                    this.indexVideo = 0;
                } else {
                    this.indexVideo = range.index;
                }
            },
            onVideoTab(val) {  // 链接与视频上传 tab切换
                if (val == 1) {
                    this.videoTab.tabUrl = true;
                    this.videoTab.tabUpd = false;
                } else {
                    this.videoTab.tabUpd = true;
                    this.videoTab.tabUrl = false;
                }
            },
            //上传视频
            uploadVideoTip(param) {
                //const formData = new FormData()
                //formData.append('file', param.file)
                //this.videoProgress = true;
                //fetchUploadVideo(formData).then(response => {
                //    this.videoForm.showVideoPath = response.videoUrl;
                //    // 获取富文本
                //    let quill = this.$refs.myQuillEditor.quill
                //    // 在光标所在位置 插入视频
                //    quill.insertEmbed(this.indexVideo, 'video', this.videoForm.showVideoPath)
                //    quill.setSelection(this.indexVideo + 1)
                //    this.videoProgress = false;
                //    this.videoFlag = false;
                //});
                this.videoProgress = true;
                var para = new FormData();
                para.append("file", param.file);
                uploadArticleFiles(para).then(res => {

                    if (util.isEmt.format(res)) {
                        //   this.addLoading = false;
                        return;
                    }
                    if (res.data.success) {
                        //this.videoForm.showVideoPath = res.data.response;
                        let url = window.server.PictureDemain + res.data.response;
                        console.log(url);
                        let quill = this.$refs.myQuillEditor.quill;
                        // 在光标所在位置 插入视频
                        quill.insertEmbed(this.indexVideo, 'video', url);
                        quill.setSelection(this.indexVideo + 1);
                        this.videoProgress = false;
                        this.videoFlag = false;
                    } else {
                        //this.$message({
                        //    message: res.data.msg,
                        //    type: "error"
                        //});
                        //this.addLoading = false;
                        this.videoProgress = false;
                    }
                });

            },
            // 上传图片链接
            upVideoUrl() {
                if (this.videoUrl) {
                    let quill = this.$refs.myQuillEditor.quill
                    quill.insertEmbed(this.indexVideo, 'video', this.videoUrl)
                    quill.setSelection(this.indexVideo + 1)
                    this.videoFlag = false;
                } else {
                    this.$message({
                        message: '请填写视频链接',
                        type: 'warning'
                    });
                }
            },
            // 图片上传
            uploadImgTip(param) {
                //const formData = new FormData()
                //formData.append('file', param.file)
                //fetchImg(formData).then(response => {
                //    let url = response.imgUrl
                //    let quill = this.$refs.myQuillEditor.quill
                //    // 插入图片链接
                //    quill.insertEmbed(this.indexVideo, 'image', url)
                //    quill.setSelection(this.indexVideo + 1)
                //});

                var para = new FormData();
                para.append("file", param.file);
                uploadArticleFiles(para).then(res => {
                    if (util.isEmt.format(res)) {
                        //   this.addLoading = false;
                        return;
                    }
                    if (res.data.success) {
                        // this.addLoading = false;
                        // //NProgress.done();
                        //this.$message({
                        //    message: res.data.msg,
                        //    type: "success"
                        //});
                        //this.IsShowZBTP = true;
                        //this.EditZBTP = res.data.response;
                        //this.EditZBTPUrl = global.EquipPictureDemain + res.data.response;
                        let url = window.server.PictureDemain + res.data.response;
                        console.log(url);
                        let quill = this.$refs.myQuillEditor.quill;
                        // 插入图片链接
                        quill.insertEmbed(this.indexVideo, 'image', url);
                        quill.setSelection(this.indexVideo + 1);
                    } else {
                        //this.$message({
                        //    message: res.data.msg,
                        //    type: "error"
                        //});
                        //this.addLoading = false;
                    }
                });
            },
            //// 文件上传
            uploadFile(param) {
                // res为图片服务器返回的数据
                var para = new FormData();
                para.append("file", param.file);
                uploadArticleFiles(para).then(res => {
                    if (util.isEmt.format(res)) {
                        //   this.addLoading = false;
                        return;
                    }
                    if (res.data.success) {
                        let url = window.server.PictureDemain + res.data.response;
                        console.log(url);
                        let quill = this.$refs.myQuillEditor.quill;;
                        let fileNameLength = param.file.name.length
                        // 插入链接
                        let length = quill.getSelection().index;
                        // quill.insertEmbed(length, 'link', {href:res.data, innerText:file.name}, "api")
                        quill.insertEmbed(length, 'link', { href: url, innerText: param.file.name })
                        quill.setSelection(length + fileNameLength)

                    } else {
                    }
                });


                //// 获取富文本组件实例
                //let quill = this.$refs.myQuillEditor.quill;
                //// 如果上传成功
                //if (res.code === 200) {
                //    let fileNameLength = file.name.length
                //    // 插入链接
                //    let length = quill.getSelection().index;
                //    // quill.insertEmbed(length, 'link', {href:res.data, innerText:file.name}, "api")
                //    quill.insertEmbed(length, 'link', { href: res.data, innerText: file.name })
                //    quill.setSelection(length + fileNameLength)
                //} else {
                //    this.$message.error("插入失败");
                //}
                /*// loading动画消失*/
                this.quillUpdateImg = false;
            },

        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill;
            }
        },
        mounted() {
            this.handleQuery();

            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            this.buttonList = getButtonList(this.$route.path, routers);
        },
};
</script>

<style scoped>
    .custom-tbl /deep/ .has-gutter .el-checkbox {
        display: none;
    }



    /*// 视频上传组件*/
    .editerV /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px;
    }

    .editerVideo {
        width: 100%;
    }

    .editerVideo_title {
        display: flex;
        height: 30px;
        line-height: 30px;
        width: 100%;
        color: #1f2f3d;
        font-weight: bold;
        justify-content: flex-start;
        border-bottom: 2px solid #DCDFE6;
    }

    .editerVideo_title_act {
        color: #409eff;
        border-bottom: 2px solid #409eff;
        margin-bottom: -2px;
    }

    .editerVideo_title_item {
        margin-right: 10px;
    }

    .editerVideo_main {
        width: 100%;
        height: 120px;
    }

    .editerVideo_main_url {
        width: 100%;
        height: 200px;
        line-height: 30px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 35px;
    }

    .avatar-uploader_video {
        width: 100px;
        height: 100px;
        border: 1px solid #D9D9D9;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
    }

    .avatar-uploader-videoiocn {
        font-size: 28px;
        color: #D9D9D9;
        line-height: 90px;
        text-align: center;
    }

    .videoProgress {
        margin-top: 30px;
    }

    .quillWidthmain {
        width: 800px;
        height: 320px;
    }

    .quillWidth {
        width: 800px;
        height: 270px;
    }

    .ql-upload {
        background: url("./../../assets/upload.svg") !important;
        background-size: 20px 20px !important;
        background-position: center center !important;
        background-repeat: no-repeat !important;
    }
</style>
